import { createAction } from '@ngrx/store';
import { ElementsVisibilityState } from '@/app/api/plyca-dtos';

export const enum ElementVisibilityActionsTypes {
  SetElementVisibility = '[Element Visibility] Set Element Visibility'
}

export const setElementVisibility = createAction(ElementVisibilityActionsTypes.SetElementVisibility, ({ visibilityState }: { visibilityState: ElementsVisibilityState }) => ({
  payload: { visibilityState }
}));
